import { render } from "./QuizPreview.vue?vue&type=template&id=6c5fabdb&scoped=true"
import script from "./QuizPreview.vue?vue&type=script&lang=js"
export * from "./QuizPreview.vue?vue&type=script&lang=js"

import "./QuizPreview.vue?vue&type=style&index=0&id=6c5fabdb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c5fabdb"]])

export default __exports__